import { isly } from "isly";
export var Second;
(function (Second) {
    var _a;
    Second.values = [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
        "60",
    ];
    _a = isly
        .string("value", ...Second.values)
        .rename("isoly.Time.Second")
        .bind(), Second.type = _a.type, Second.is = _a.is, Second.flawed = _a.flawed;
    let Numeric;
    (function (Numeric) {
        var _a;
        Numeric.values = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
        ];
        _a = isly
            .number("value", ...Numeric.values)
            .rename("isoly.Time.Second.Numeric")
            .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    })(Numeric = Second.Numeric || (Second.Numeric = {}));
    function parse(value) {
        return Second.Numeric.type.get(Number.parseInt(value));
    }
    Second.parse = parse;
    function create(value) {
        return Second.type.get(value.toString().padStart(2, "0"));
    }
    Second.create = create;
})(Second || (Second = {}));
//# sourceMappingURL=Second.js.map